module.exports = __webpack_public_path__ + "img/brand-12.ca9718e7.png";